import type { TFunction } from 'i18next';

export const WEB_SEARCH_TOOL_NAME = 'web_search';

export const KNOWN_CHAT_TOOL_NAMES = [
  'activity_logs_list',
  'analytics_component_create',
  'analytics_component_delete',
  'analytics_component_draft',
  'analytics_component_get',
  'analytics_component_update',
  'analytics_components_list',
  'analytics_components_regenerate',
  'analytics_dashboard_create',
  'analytics_dashboard_delete',
  'analytics_dashboard_draft',
  'analytics_dashboard_get',
  'analytics_dashboard_members_update',
  'analytics_dashboard_update',
  'analytics_dashboards_list',
  'calculate-bmi',
  'chat_attachments_add_to_document_hub',
  'collect-feedback',
  'custom_emission_factor_get',
  'custom_emission_factors_create',
  'custom_emission_factors_delete',
  'custom_emission_factors_list',
  'custom_emission_factors_update',
  'data_point_get',
  'data_points_assign',
  'data_points_complete',
  'data_points_create',
  'data_points_list',
  'data_points_needed_documents',
  'data_points_remind',
  'data_points_update_value',
  'delete-file',
  'documents_confirm_upload',
  'documents_delete',
  'document_folders_create',
  'document_folders_delete',
  'document_folders_list',
  'document_folders_rename',
  'document_get',
  'document_preview_url_get',
  'documents_list',
  'documents_move',
  'documents_prepare_upload',
  'facilities_create',
  'facilities_delete',
  'facilities_list',
  'facilities_update',
  'facility_get',
  'facility_global_get',
  'fetch-data',
  'list-files',
  'list-workspace-files',
  'new_report_get',
  'new_reports_calculate_html',
  'new_reports_create',
  'new_reports_create_custom',
  'new_reports_delete',
  'new_reports_export_vsme',
  'new_reports_list',
  'new_reports_update_title',
  'process-files',
  'product_components_create',
  'product_components_delete',
  'product_components_update',
  'product_get',
  'products_create',
  'products_delete',
  'products_list',
  'products_update',
  'projects_list',
  'report_templates_get',
  'report_templates_list',
  'summarize',
  'supplier_facilities_create',
  'supplier_facilities_delete',
  'supplier_facilities_update',
  'supplier_get',
  'supplier_request_get',
  'supplier_requests_accept',
  'supplier_requests_cancel',
  'supplier_requests_close',
  'supplier_requests_create',
  'supplier_requests_list',
  'supplier_requests_publish',
  'supplier_requests_summary',
  'suppliers_cancel_invite',
  'suppliers_create_invited',
  'suppliers_create_managed',
  'suppliers_delete',
  'suppliers_invite_managed',
  'suppliers_list',
  'suppliers_resend_invite',
  'suppliers_search',
  'suppliers_update',
  'task_get',
  'tasks_create',
  'tasks_delete',
  'tasks_list',
  'tasks_move',
  'tasks_update',
  WEB_SEARCH_TOOL_NAME,
] as const;

export type KnownChatToolName = (typeof KNOWN_CHAT_TOOL_NAMES)[number];

const KNOWN_CHAT_TOOL_NAME_SET: ReadonlySet<string> = new Set(KNOWN_CHAT_TOOL_NAMES);

export function isKnownChatToolName(toolName: string): toolName is KnownChatToolName {
  return KNOWN_CHAT_TOOL_NAME_SET.has(toolName);
}

export function prettifyToolName(toolName: string) {
  return toolName
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase() + part.slice(1))
    .join(' ');
}

export function getKnownToolDisplayName(toolName: string, t: TFunction) {
  return isKnownChatToolName(toolName)
    ? t(`modules.mavue2.chat.toolNames.${toolName}`, { defaultValue: prettifyToolName(toolName) })
    : null;
}

export function getToolDisplayName(
  call: { toolName: string; title?: string | null },
  t: TFunction
) {
  return (
    getKnownToolDisplayName(call.toolName, t) ??
    call.title?.trim() ??
    prettifyToolName(call.toolName)
  );
}
